import teal from '@material-ui/core/colors/teal';
import pink from '@material-ui/core/colors/pink';
import grey from '@material-ui/core/colors/grey';

export default {
    palette: {
        common: {
          black: '#000',
          white: '#fff',
          dark: '#020202',
        },
        primary: {
            light: teal[300],
            main: teal[500],
            dark: teal[700],
            contrastText: '#fff'
        },
        secondary: {
            light: pink[300],
            main: pink[600],
            dark: pink[800],
            contrastText: '#fff'
        },
        grey: {
          light: grey[200],
          main: grey[300],
          dark: grey[800],
          contrastText: '#000'
        },
        borderColor: {
          main: 'rgba(0, 0, 0, 0.06)',
          dark: 'rgba(0, 0, 0, 0.12)',
        },
    },
    status: {
        danger: 'orange',
    },
    typography: {
        button: {
            fontWeight: 400,
            textAlign: 'capitalize'
        },
    },
    overrides: {
        MuiTooltip: {
          tooltip: {
            fontSize: "14px",
            color: "white",
            backgroundColor: "#444444"
          }
        },
        MuiCard: {
          root: {
            boxShadow: '0 4px 6px rgba(47, 43, 61,.1),0 0 transparent,0 0 transparent',
            borderRadius: '5px'
          }
        },
        MuiButton: {
          root: {
            // textTransform: 'none'
          } 
        }
      }
};
